import { AxiosInstance } from "axios";
import { IMenuItem } from "types/menu";

class MenuApi {
	http: AxiosInstance;
	constructor(axiosInstance: AxiosInstance) {
		this.http = axiosInstance;
	}

	get = () => this.http.get<IMenuItem[]>("menu");
}

export default MenuApi;
